import "core-js/modules/es6.array.map";
import React from "react";
import ClassNames from "classnames";

var NavFooter = function NavFooter(_ref) {
  var pages = _ref.pages;
  var classNames = ClassNames("footer__nav", "nav-footer");
  return React.createElement("nav", {
    className: classNames
  }, React.createElement("ul", {
    className: "nav-footer__items"
  }, pages.map(function (_ref2, i) {
    var label = _ref2.label,
        path = _ref2.path;
    return React.createElement("li", {
      key: i,
      className: "nav-footer__item"
    }, React.createElement("a", {
      href: path
    }, label));
  })));
};

export default NavFooter;